// Placeholder keyword lists are persisted into domain_knowledge as JSON array
// strings by the user-facing safety config. Admin-authored entries in the Console
// are plain prose though (e.g. "Nike, Adidas"), so parse defensively: fall back to
// splitting on commas rather than dropping the value.
export const parseKeywordList = (value: string | undefined): string[] => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed.filter((v): v is string => typeof v === "string");
  } catch {
    // Not JSON — fall through to the comma-separated interpretation below.
  }
  return value
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);
};

export const serializeKeywordList = (values: string[]): string => JSON.stringify(values);
